// Libraries
import {
  Component,
  Input
} from '@angular/core';

// Models
import {
  RepairSet,
  REPAIR_STATUSES
} from '../models';

/**
 * `RepairSetStatusComponent` implements a view to show the status of a repair set.
 */
@Component({
  selector: 'she-repair-set-status',
  template: `<span class="she-status-repair-set she-status-repair-set-{{repair?.status}}">{{getStatus()}}</span>`
})
export class RepairSetStatusComponent {
  /**
   * Current repair set.
   */
  @Input() repair: RepairSet;

  /**
   * Creates a new `RepairSetStatusComponent` instance.
   */
  constructor() {}

  /**
   * Returns the status of current repairs set.
   * @return Repair status
   */
  public getStatus(): string {
    return this.repair ? REPAIR_STATUSES[this.repair.status] : '';
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/components/repair-set-status.component.ts